import React from "react";
import instruction from "../assets/Logo-investek.png";
import { Box, Button, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";

const Instruction = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const navigate = useNavigate();
  const handlenext = () => {
    navigate("/addreferral");
  };

  const handleCancel = () => {
    navigate("/dashboard");
    // console.log("cancel");
  };

  return (
    <>
      {isSmallScreen ? (
        <span>
          {" "}
          <Box sx={styles.formboxresponsive}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <img src={instruction} alt="" />
            <Typography
              sx={{ fontSize: "20px", fontWeight: "bold", marginTop: "4px" }}
            >
              Welcome aboard!
            </Typography>
            <div>
              Please explore the features of the application and provide your
              feedback to InvesTek's Wealth Advisor.
            </div>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2rem",
              }}
            >
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  border: "1px solid #d9d9d9",
                  borderRadius: "50%",
                  background: "#d9d9d9",
                }}
              />
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  border: "1px solid #002C51",
                  borderRadius: "50%",
                  margin: "0px 5px",
                  background: "#002C51",
                }}
              />
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  border: "1px solid #d9d9d9",
                  borderRadius: "50%",
                  background: "#d9d9d9",
                }}
              />
            </Box>
            <Button onClick={handlenext} sx={styles.btn}>
              Get started
            </Button>
          </Box>
        </span>
      ) : (
        <span>
          {" "}
          <Box sx={styles.formbox}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <img src={instruction} alt="" />
            <Typography
              sx={{ fontSize: "20px", fontWeight: "bold", marginTop: "4px" }}
            >
              Welcome aboard!
            </Typography>
            <div>
              Please explore the features of the application and provide your
              feedback to InvesTek's Wealth Advisor.
            </div>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2rem",
              }}
            >
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  border: "1px solid #d9d9d9",
                  borderRadius: "50%",
                  background: "#d9d9d9",
                }}
              />
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  border: "1px solid #002C51",
                  borderRadius: "50%",
                  margin: "0px 5px",
                  background: "#002C51",
                }}
              />
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  border: "1px solid #d9d9d9",
                  borderRadius: "50%",
                  background: "#d9d9d9",
                }}
              />
            </Box>
            <Button onClick={handlenext} sx={styles.btn}>
              Get started
            </Button>
          </Box>
        </span>
      )}
    </>
  );
};

export default Instruction;

const styles = {
  formbox: {
    position: "absolute",
    top: "52%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "30px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "420px",
    width: "420px",
  },
  formboxresponsive: {
    position: "absolute",
    top: "52%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "30px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "420px",
    width: "300px",
  },
  formboxtwo: {
    position: "absolute",
    top: "82%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "30px",
    width: "520px",
  },
  btn: {
    marginTop: "3em",
    width: "12em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    width: "400px",
  },
};
